import { Module } from 'vuex';
import { RootState } from '..';
import { Floor } from '@/utils/api';
import getFloorByID from '@/utils/helpers/getFloorByID';
import { FloorState } from '@/store/modules/app';

const RESET_STATE = 'RESET_STATE';

const atticInitialState = (): FloorState => ({
  floorID: 'ROF',
  zoneID: 'ROZA'
});

export const atticModule: Module<FloorState, RootState> = {
  namespaced: true,
  state: atticInitialState(),
  getters: {
    floor(_state, _getters, rootState): Floor | undefined {
      return getFloorByID(rootState.configuration.houseConfiguration?.floors || [], _state.floorID, _state.zoneID);
    },
    activeZone(_state, _getters) {
      return _getters.floor.zones[0];
    }
  },
  actions: {
    resetState({ commit }) {
      commit(RESET_STATE);
    }
  },
  mutations: {
    [RESET_STATE](state) {
      Object.assign(state, atticInitialState());
    }
  }
};
